import { useContext, useEffect, useState } from "react";
import { ApprovalContext } from "./Approvals";
import css3 from "../css/approval-table.module.css";
import { FiMoreHorizontal as MoreIcon } from "react-icons/fi";
import {
  MdOutlineArrowBackIosNew as LBtn,
  MdOutlineArrowForwardIos as RBtn,
} from "react-icons/md";
import { format, parseISO } from "date-fns";

const ApprovalTable = (props: any) => {
  const [activeData, setActiveData] = useState<any>([]);
  const [pageData, setPageData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [pageArr, setPageArr] = useState<any>([]);
  const [showMore, setShowMore] = useState<boolean>(false);
  const [showIndex, setShowIndex] = useState<any>(null);
  const { setShowModal, setModalView, setModalData } =
    useContext(ApprovalContext);

  const data: any = props?.data.Data ? props?.data?.Data : props?.data;

  const DATA_PER_PAGE = 10;

  const handlePrevous = () => {
    if (currentPage === 0) {
      if (pageArr.length > 1) {
        setCurrentPage(pageArr.at(-1));
        return false;
      }
      setCurrentPage(0);
      return false;
    }
    setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (pageArr.length > 1) {
      if (currentPage === pageArr.at(-1)) {
        setCurrentPage(0);
        return false;
      }
      setCurrentPage(currentPage + 1);
      return false;
    }
    setCurrentPage(0);
  };

  const handleMore = (index: number) => {
    if (index == showIndex) {
      setShowIndex(null);
      setShowMore(false);
      return;
    }
    setShowIndex(index);
    setShowMore(true);
  };

  const handleViewDetails = (data: any) => {
    setModalView("view");
    setShowModal(true);
    setModalData(data);
  };

  const handleApproveOrDecline = (data: any) => {
    setModalView("approve");
    setShowModal(true);
    setModalData(data);
  };

  useEffect(() => {
    if (data && data.length > 0) {
      setActiveData(data);

      let lastPage = Math.ceil(data.length / 10);
      let i = 0;
      let arr = [];
      for (i = 0; i < lastPage; i++) {
        arr.push(i);
      }

      setPageArr(arr);
      setPageData(data.slice(0, DATA_PER_PAGE));
    }
  }, [data]);

  useEffect(() => {
    if (activeData && activeData.length > 0) {
      let start = currentPage * DATA_PER_PAGE;
      let stop = start + DATA_PER_PAGE;
      setPageData(data.slice(start, stop));
    }
  }, [currentPage]);

  const formatDate = (date: string) => {
    if (!date) return "";

    const parsedDate = parseISO(date);
    const formattedDate = format(parsedDate, "d MMM yyyy");

    return formattedDate;
  };

  return (
    <div className={css3.container}>
      <>
        <div
          style={{ gridTemplateColumns: `0.6fr 0.6fr 0.6fr 1.3fr 0.6fr 0.4fr 0.8fr` }}
        >
          <div>ApplicationDate</div>
          <div>First Name</div>
          <div>Surname Name</div>
          <div>Email Address</div>
          <div>Phone</div>
          <div> Score</div>
          <div>Approval Status</div>
        </div>
        <div>
          {pageData &&
            pageData.length > 0 &&
            pageData.map((eData: any, index: number): any => (
              <div
                key={index}
                style={{
                  gridTemplateColumns: `0.6fr 0.6fr 0.6fr 1.3fr 0.6fr 0.4fr 0.8fr`,
                }}
              >
                <div>{formatDate(eData?.ApplicationDate)}</div>
                <div>{eData.FirstName}</div>
                <div>{eData.LastName}</div>
                <div>{eData.Email || "N/A"}</div>
                <div>{eData.PhoneNumber || "N/A"}</div>
                <div>{eData.TotalScore || "N/A"}</div>
                <div>
                  <div>{eData?.Status === 0 ? "pending" : "Approved"}</div>

                  <span
                    className={`${css3.moreSpan} ${
                      index == showIndex ? `${css3.activeMore}` : ""
                    } `}
                    onClick={() => handleMore(index)}
                  >
                    <MoreIcon />
                    {index == showIndex && showMore ? (
                      <div>
                        <div onClick={() => handleViewDetails(eData)}>
                          View Details
                        </div>

                        <div onClick={() => handleApproveOrDecline(eData)}>
                          Decline | Approve
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </div>
            ))}
        </div>

        <div className={css3.pagination}>
          <div>
            <button
              onClick={handlePrevous}
              className={`${css3.lBtn} ${css3.btn}`}
            >
              <LBtn />
            </button>
            {pageArr &&
              pageArr.length > 0 &&
              pageArr.map((ePage: number, index: number) => {
                if (index <= 2 && currentPage <= 2)
                  return (
                    <span
                      style={
                        ePage == currentPage
                          ? {
                              backgroundColor: "var(--activeP-back)",
                              color: "var(--white-color)",
                            }
                          : {}
                      }
                      key={ePage}
                      onClick={() => setCurrentPage(ePage)}
                    >
                      {ePage + 1}
                    </span>
                  );

                if (index == currentPage)
                  return (
                    <span
                      style={
                        ePage == currentPage
                          ? {
                              backgroundColor: "var(--activeP-back)",
                              color: "var(--white-color)",
                            }
                          : {}
                      }
                      key={ePage}
                      onClick={() => setCurrentPage(ePage)}
                    >
                      {ePage + 1}
                    </span>
                  );

                if (
                  index >= pageArr.length - 3 &&
                  currentPage >= pageArr.length - 3
                )
                  return (
                    <span
                      style={
                        ePage == currentPage
                          ? {
                              backgroundColor: "var(--activeP-back)",
                              color: "var(--white-color)",
                            }
                          : {}
                      }
                      key={ePage}
                      onClick={() => setCurrentPage(ePage)}
                    >
                      {ePage + 1}
                    </span>
                  );

                if (index == pageArr.length - 1)
                  return (
                    <>
                      <>...</>
                      <span
                        style={
                          ePage == currentPage
                            ? {
                                backgroundColor: "var(--activeP-back)",
                                color: "var(--white-color)",
                              }
                            : {}
                        }
                        key={ePage}
                        onClick={() => setCurrentPage(ePage)}
                      >
                        {ePage + 1}
                      </span>
                    </>
                  );

                if (index == 0)
                  return (
                    <>
                      <span
                        style={
                          ePage == currentPage
                            ? {
                                backgroundColor: "var(--activeP-back)",
                                color: "var(--white-color)",
                              }
                            : {}
                        }
                        key={ePage}
                        onClick={() => setCurrentPage(ePage)}
                      >
                        {ePage + 1}
                      </span>
                      <>...</>
                    </>
                  );
              })}
            <button onClick={handleNext} className={`${css3.rBtn} ${css3.btn}`}>
              <RBtn />
            </button>
          </div>
        </div>
      </>
    </div>
  );
};

export default ApprovalTable;
